export function resize_iframe(obj) {
    if (obj.contentWindow.document.body) {
	obj.style.height = obj.contentWindow.document.body.scrollHeight + 'px';
    }
}

String.prototype.capitalize_first = function()
{
    return this.charAt(0).toUpperCase() + this.slice(1);
}

export function truncate_string_with_ellipsis(str, num) {
    return str.length > num ? str.slice(0, num > 3 ? num - 3 : num) + "..." : str ;
}

function create_err_div_from_string(jsonText){
    return create_err_div(JSON.parse(jsonText));
}

export function create_err_div(json){
    var ul = $("<ul></ul>");
    Object.keys(json).forEach(function(key){
	var errors = json[key];
	for(var i = 0; i < errors.length; i++){
	    $("<li></li>").text(key.capitalize_first() + ' ' + errors[i] + '.').appendTo(ul);
	}
    });
    return $('<div/>', {"class": "error_explanation"})
	.append($('<div/>', {"class": 'alert alert-danger'})
		.append(ul));
}

export function disp_xhr_error(form_node, xhr){
    var form = $(form_node);

    remove_xhr_form_error(form);
    form.prepend(create_err_div_from_string(xhr.responseText));
}

export function remove_xhr_form_error(form){
    form.find('.error_explanation').remove();
}

export function init_table_check_all_box(){
    $('thead input[name="check_all_box"]').click(function() {
	$(this).closest('table').find('tbody tr input[type="checkbox"]').prop('checked', this.checked);
    });
}
